export const isRoutePrivate = (privateRoutes: Record<string, string> | null): boolean => {
  return privateRoutes
    ? Object.values(privateRoutes).includes(window.location.pathname.slice(1))
    : true;
};
